module.exports = __webpack_public_path__ + "img/album06_08.c26333fa.jpg";